import { useCallback, useSyncExternalStore } from 'react';
import { toLoading, toEmpty } from '../resolvers/definition/resolverState';
import { useKey } from './useKey';
import { getPulseClient } from '../client/client';
import { normalizeResourceOptions } from '../resources/descriptors';
export { skipToken, isSkipToken, emptyInitialParams, normalizeResourceOptions } from '../resources/descriptors';
export const initial = Object.freeze(toLoading()());
export const skipped = toEmpty()();
export const usePulseClient = () => getPulseClient();
export const useParseOptions = (resource, options) => {
  const {
    params,
    skip,
    pollInterval,
    pollGroup,
    httpClient,
    passive
  } = normalizeResourceOptions(options);
  const instanceKey = useKey(resource, params);
  return {
    params,
    skip,
    pollInterval,
    pollGroup,
    httpClient,
    passive,
    instanceKey
  };
};
export const useSyncResource = (getSnapshot, instanceKey, resource, params, skip, pollInterval, client, httpClient, pollGroup, passive) => {
  const subscribe = useCallback(callback => {
    if (skip || !client) {
      return () => {};
    }
    return client.watch({
      resource,
      params,
      instanceKey,
      pollInterval,
      httpClient,
      pollGroup,
      passive
    }, callback);
  },
  // instanceKey is a proxy for params and resource type changing
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [client, instanceKey, pollInterval, pollGroup, skip, passive]);
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
};